import { createAction, props } from '@ngrx/store';

// Define all the actions
export const updateFlightQuoteData = createAction(
  '[FlightFinder] Update Flight Quote Data',
  props<{ payload: any }>()
);

export const updateFlightQuoteCacheRequest = createAction(
  '[FlightFinder] Update Flight Quote Cache Request',
  props<{ payload: any }>()
);

export const updateFlightQuoteResults = createAction(
  '[FlightFinder] Update Flight Quote Results',
  props<{ payload: any }>()
);

export const updatePaginationData = createAction(
  '[FlightFinder] Update Pagination Data',
  props<{ payload: any }>()
);

export const updateFlightConnectionCount = createAction(
  '[FlightFinder] Update Flight Connection Count',
  props<{ payload: number }>()
);

export const incrementRequestCount = createAction('[FlightFinder] Increment Request Count');
export const setRequestCount = createAction(
  '[FlightFinder] Set Request Count',
  props<{ payload: number }>()
);

export const setRequestLegs = createAction(
  '[FlightFinder] Set Request Legs',
  props<{ payload: number }>()
);

export const updateApiSearch = createAction(
  '[FlightFinder] Update API Search',
  props<{ payload: boolean }>()
);

export const updateFilterLegs = createAction(
  '[FlightFinder] Update Filter Legs',
  props<{ payload: any }>()
);

export const updateUserSelected = createAction(
  '[FlightFinder] Update User Selected',
  props<{ payload: boolean }>()
);

export const updateDatalinkSession = createAction(
  '[FlightFinder] Update Datalink Session',
  props<{ payload: any }>()
);

export const updateDatalinkError = createAction(
  '[FlightFinder] Update Datalink Error',
  props<{ payload: boolean }>()
);

export const updateFlightNumberRequest = createAction(
  '[FlightFinder] Update Flight Number Request',
  props<{ payload: any }>()
);

export const updateFlightNumberResult = createAction(
  '[FlightFinder] Update Flight Number Result',
  props<{ payload: any }>()
);

export const updateRedirectToSearch = createAction(
  '[FlightFinder] Update Redirect To Search',
  props<{ payload: boolean }>()
);

export const updateSessionUsed = createAction(
  '[FlightFinder] Update Session Used',
  props<{ payload: boolean }>()
);

export const updateSelectedMultiLegFlight = createAction(
  '[FlightFinder] Update Selected Multi Leg Flight',
  props<{ payload: any }>()
);

export const updateReturnSessionString = createAction(
  '[FlightFinder] Update Return Session String',
  props<{ payload: string }>()
);

export const updateReturnSessionId = createAction(
  '[FlightFinder] Update Return Session ID',
  props<{ payload: string }>()
);

export const updateReturnCustomerUrl = createAction(
  '[FlightFinder] Update Return Customer URL',
  props<{ payload: string }>()
);

export const updatePromoFromUrl = createAction(
  '[FlightFinder] Update Promo From URL',
  props<{ payload: any }>()
);

export const updateProductTierFromUrl = createAction(
  '[FlightFinder] Update Product Tier From URL',
  props<{ payload: any }>()
);

export const updateCsMotoFromUrl = createAction(
  '[FlightFinder] Update CS Moto From URL',
  props<{ payload: boolean }>()
);

export const updateAirlineSearchString = createAction(
  '[FlightFinder] Update Airline Search String',
  props<{ payload: string }>()
);

export const resetFilterLegs = createAction('[FlightFinder] Reset Filter Legs');
export const resetFlightQuoteData = createAction('[FlightFinder] Reset Flight Quote Data');
export const resetFlightQuoteResults = createAction('[FlightFinder] Reset Flight Quote Results');
export const resetSelectedMultiLegFlight = createAction('[FlightFinder] Reset Selected Multi Leg Flight');
export const refreshFlightFinder = createAction(
  '[FlightFinder] Refresh Flight Finder',
  props<{ payload: any }>()
);

export const resetFlightFinder = createAction('[FlightFinder] Reset Flight Finder');
